// Link targets shared by the navigation, footer and legal pages.

// A section on the home page, reachable from any route.
export const sectionPath = id => ({ pathname: "/", hash: `#${id}` });

export const legalPages = [
  { path: "/privacy-policy", label: "Privacy Policy" },
  { path: "/terms-of-use", label: "Terms of Use" },
  { path: "/cookie-policy", label: "Cookie Policy" },
  { path: "/legal-notice", label: "Legal Notice" },
];
